import {
    MIN_LUA_DISPLAY_INTERVAL_MS,
    getUserCustomLuas,
    luaBatchReceived,
    luaRemoved,
    setLuasActive,
} from 'redux/slices/liveUserActions'

import { sendLUA } from 'redux/slices/liveUserActions/thunks'
import { activate as activateWordFlow, isWordFlowActive, getEndDate as wordFlowEndDate } from 'redux/slices/wordFlow'
import { finish as finishWordFlow, resume as resumeWordFlow } from 'redux/slices/wordFlow/thunks'
import { addNewMessage, retrieveInitialMessages } from 'redux/slices/chat'
import { bindActionCreators, compose } from 'redux'
import { isMobile, maxScroll, supportsFlagEmoji } from 'utils'

import ChatMessageList from 'components/set/ChatMessageList/ChatMessageList'
import Constants from 'constants.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Form from 'react-bootstrap/Form'
import { LuaButton } from 'components/set/Chat/LuaButton/LuaButton'
import React from 'react'
import ScrollCaret from 'components/set/Chat/ScrollCaret/ScrollCaret'
import WordFlow from 'components/common/WordFlow/WordFlow'
import _ from 'lodash'
import { connect } from 'react-redux'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { getShowChannel } from 'redux/slices/interaction'
import { isSmartTV } from 'utils'
import moment from 'moment'
import { openModal, ModalContent } from 'redux/slices/globalModal'
import { sendMessage } from 'redux/slices/chat'
import { styles } from './styles'
import { withStyles } from '@material-ui/core'
import { themeObj } from 'styling/theme'
import clsx from 'clsx'

export class Chat extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            formScrolled: false,
            formFullyScrolled: false,
            isWordFlowActive: props.isWordFlowActive,
            showWordFlow: false,
        }
    }

    componentDidMount() {
        const {
            wsChannel,
            luaBatchReceived,
            activateWordFlow,
            isWordFlowActive,
            wordFlowEndDate,
            setLuasActive,
            retrieveInitialMessages,
            addNewMessage,
        } = this.props

        if (wsChannel) {
            wsChannel.bind(Constants.WEBSOCKET_CHAT_LUA_BATCH, async ({ luas }) => luaBatchReceived(luas))
            wsChannel.bind(Constants.WEBSOCKET_WORD_FLOW_ACTIVATED, async ({ endDate }) => {
                this.setState({ isWordFlowActive: true })
                activateWordFlow(endDate)
                this.props.resumeWordFlow()
            })
            wsChannel.bind(Constants.WEBSOCKET_CHAT_MESSAGE, _.throttle(addNewMessage, 100))
        }

        if (isWordFlowActive && wordFlowEndDate) {
            this.props.resumeWordFlow()
        }
        setLuasActive(true)

        // Load all messages for this channel
        retrieveInitialMessages()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isWordFlowActive && !this.props.isWordFlowActive) {
            this.setState({
                showWordFlow: false,
                isWordFlowActive: false,
            })
        }
    }

    componentWillUnmount() {
        const { wsChannel, setLuasActive } = this.props
        if (wsChannel) {
            wsChannel.unbind(Constants.WEBSOCKET_CHAT_MESSAGE)
            wsChannel.unbind(Constants.WEBSOCKET_CHAT_LUA_BATCH)
            wsChannel.unbind(Constants.WEBSOCKET_WORD_FLOW_ACTIVATED)
        }
        setLuasActive(false)
    }

    getMessageToSend = () => {
        const text = this.inputRef && this.inputRef.value
        if (_.isString(text) && text.trim().length > 0) {
            return {
                body: _.isString(text) ? text : '',
                timestamp: moment().toISOString(),
                likeUsers: [],
                userId: this.props.user._id,
                displayName: this.props.user.displayName,
                chatColor: this.props.user.chatColor || themeObj.colors.light.grey,
            }
        }
    }

    resetMessageToSend = () => {
        this.inputRef.value = ''
    }

    onSubmit = e => {
        e.preventDefault()
        //Check if user is logged in
        if (!this.props.isAuthenticated) {
            //Show login modal
            this.props.openModal({ content: ModalContent.SIGNUP })
            return
        }
        const message = this.getMessageToSend()
        if (message) {
            this.props.sendMessage(message, this.props.user)
            this.resetMessageToSend()
        }
    }

    //TODO Analyze extracting this logic to a generic component
    recalculateScrollConditions = ({ target }) => {
        if (isMobile()) return
        if (!this.state.formScrolled && target.scrollLeft > 0) this.setState({ formScrolled: true })
        if (this.state.formScrolled && target.scrollLeft === 0) this.setState({ formScrolled: false })
        if (!this.state.formFullyScrolled && target.scrollLeft >= target.scrollWidth - target.clientWidth)
            this.setState({ formFullyScrolled: true })
        if (this.state.formFullyScrolled && target.scrollLeft < maxScroll(target))
            this.setState({ formFullyScrolled: false })
    }

    scrollZero = () => this.chatForm && this.chatForm.scroll(0, 0)

    scrollFull = () => this.chatForm && this.chatForm.scroll(maxScroll(this.chatForm), 0)

    displayWordFlow = () => this.setState({ showWordFlow: true })

    hideWordFlow = () => this.setState({ showWordFlow: false })

    sendLUA = luaEmoji => {
        const now = Date.now()

        if (!this.props.isAuthenticated) {
            this.props.openModal({ content: ModalContent.SIGNUP })
            return
        }

        if (now - this.lastCall < MIN_LUA_DISPLAY_INTERVAL_MS) return

        this.props.sendLUA(this.props.show._id, luaEmoji, this.props.user)
        this.lastCall = Date.now()
    }

    renderInputForm() {
        //TODO Refactor form handling and get rid of refs
        const classes = this.props.classes

        return (
            <div
                className={clsx(classes.chatInputContainer, {
                    [classes.fullScreen]: this.props.fullScreen,
                })}
            >
                {!isMobile() && this.state.formScrolled && <ScrollCaret onClick={this.scrollZero} orientation="left" />}
                <Form
                    action="#"
                    onScroll={this.recalculateScrollConditions}
                    ref={div => (this.chatForm = div)}
                    className={classes.chatForm}
                    onSubmit={this.onSubmit}
                    id="chat-form"
                >
                    <input
                        ref={el => (this.inputRef = el)}
                        className={!isSmartTV ? classes.chatInput : classes.tvChatInput}
                        as="input"
                        placeholder="Comment"
                        maxLength="175"
                    />
                    <div className={classes.luaButtons}>
                        <button
                            className={classes.chatSendButton}
                            type="submit"
                            onClick={this.onSubmit}
                            id="chat-send-btn"
                        >
                            <FontAwesomeIcon icon={faPaperPlane} color="#D3D5DB" />
                        </button>
                        {this.props.userCustomLuas.map(lua => {
                            return (
                                <LuaButton
                                    isUnicode={false}
                                    key={lua.luaPassTierId}
                                    onClick={this.sendLUA}
                                    emoji={lua.luaPassTierImgUrl}
                                />
                            )
                        })}
                        {this.props.show.displayFlagLUA && (
                            <LuaButton
                                isUnicode
                                onClick={this.sendLUA}
                                emoji={supportsFlagEmoji() ? _.get(this.props.user, 'country.emoji', '🤘') : '🤘'}
                            />
                        )}
                        <LuaButton isUnicode onClick={this.sendLUA} emoji={'👏'} />
                        <LuaButton isUnicode onClick={this.sendLUA} emoji={'❤️'} />
                        <LuaButton isUnicode onClick={this.sendLUA} emoji={'🔥'} />
                        <LuaButton isUnicode onClick={this.sendLUA} emoji={'😂'} />
                    </div>
                </Form>
                {!isMobile() && !this.state.formFullyScrolled && (
                    <ScrollCaret onClick={this.scrollFull} orientation="right" />
                )}
            </div>
        )
    }

    render() {
        const classes = this.props.classes

        if (this.state.showWordFlow) {
            return <WordFlow onClose={this.hideWordFlow} />
        }

        return (
            <div className={classes.chatbox}>
                {this.state.isWordFlowActive && (
                    <div className={classes.wordFlowBtnWrapper}>
                        <button id="wordflow-enter" className={classes.wordFlowBtn} onClick={this.displayWordFlow}>
                            A question was asked - tap to answer
                        </button>
                    </div>
                )}
                <ChatMessageList fullScreen={this.props.fullScreen} />
                {this.renderInputForm()}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    wsChannel: getShowChannel(state),
    isWordFlowActive: isWordFlowActive(state),
    wordFlowEndDate: wordFlowEndDate(state),
    userCustomLuas: getUserCustomLuas(state),
})
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openModal,
            addNewMessage,
            sendMessage,
            retrieveInitialMessages,
            sendLUA,
            luaRemoved,
            luaBatchReceived,
            setLuasActive,
            activateWordFlow,
            finishWordFlow,
            resumeWordFlow,
        },
        dispatch,
    )

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Chat)
